import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Seo } from "../components/Seo";

export default function ProCancelPage() {
    return (
        <main className="py-24 px-6 max-w-2xl mx-auto text-center min-h-[50vh]">
            <Seo title="Pagamento cancelado — ScorpionPDF" description="O checkout foi cancelado. Nenhuma cobrança foi feita." noindex />
            <XCircle className="w-14 h-14 text-gray-500 mx-auto" aria-hidden="true" />
            <h1 className="font-poster text-4xl text-black mt-4">PAGAMENTO CANCELADO</h1>
            <p className="text-gray-600 mt-3">
                Nenhuma cobrança foi feita. As ferramentas gratuitas continuam disponíveis normalmente.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                <Link
                    to="/planos"
                    data-testid="pro-cancel-retry-link"
                    className="px-8 py-4 bg-[#0284C7] hover:bg-black text-white font-poster text-xl tracking-wide transition-colors"
                >
                    TENTAR NOVAMENTE
                </Link>
                <Link
                    to="/ferramentas"
                    data-testid="pro-cancel-tools-link"
                    className="px-8 py-4 border-2 border-black bg-white hover:bg-black hover:text-white text-black font-poster text-xl transition-colors"
                >
                    USAR GRÁTIS
                </Link>
            </div>
        </main>
    );
}
